import Navbar from "./components/Navbar";
import Ticker from "./components/Ticker";
import Hero from "./components/Hero";
import MelonField from "./components/MelonField";
import WeekReview from "./components/WeekReview";
import DeepDive from "./components/DeepDive";
import Discuss from "./components/Discuss";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-800 overflow-x-hidden">
      <Navbar />
      <div className="h-[64px] lg:h-[116px]" aria-hidden="true"></div>
      <Ticker />
      <main>
        <Hero />
        <MelonField />
        <WeekReview />
        <DeepDive />
        <Discuss />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}